import type { FC, PropsWithChildren } from 'react';
import { InputsSection, InputBox, ModalButtons, ModalForm, Modal, TextArea } from '../../components/Modal';
import { ToggleSwitchWithLabel } from '../../components';
import ModalHeading from '../../components/Modal/ModalHeading';
import AddUserSkeleton from '../../Skeletons/AddUserSkeleton';

import { IClinic } from '../../hooks/clinic/index.type';
import TextBox from '../../components/Modal/InputBox/TextBox.module.css';
import { inputPhoneMasking } from '../../utils/validators';

export type AddEditModalState = PropsWithChildren<{
  status: boolean;
  data?: IClinic;
}>;
export type IaddEditModalStates = PropsWithChildren<{
  name: { value: string; error: string };
  email: { value: string; error: string };
  phone: { value: string; error: string };
  address: { value: string; error: string };
  password: { value: string; error: string };
  modules: { value: { fileSharing: boolean; checkIn: boolean; questionnaire: boolean }; error: string };
}>;

type AddEditModalProps = PropsWithChildren<{
  loading: boolean;
  addEditModal: AddEditModalState;
  onCloseModal?: () => void;
  handleAddEdit?: (event: React.FormEvent<HTMLFormElement>) => void;
  addEditModalStates: IaddEditModalStates;
  setAddEditModalStates: React.Dispatch<React.SetStateAction<IaddEditModalStates>>;
}>;

const AddEditModal: FC<AddEditModalProps> = props => {
  return (
    <Modal show={props.addEditModal.status}>
      <ModalHeading heading={props.addEditModal.data && props.addEditModal.data._id ? 'Update Clinic Data' : 'Add New Clinic'} />
      {props.loading ? (
        <AddUserSkeleton />
      ) : (
        <ModalForm style={{ marginBottom: '2.5rem' }} onSubmit={props.handleAddEdit}>
          <InputsSection>
            <InputBox
              label='Clinic Name'
              placeholder='eg, John&#39;s Clinic'
              value={props.addEditModalStates.name.value}
              onChange={event => {
                props.setAddEditModalStates(prevVal => ({ ...prevVal, name: { value: event.target.value, error: '' } }));
              }}
              errorMessage={props.addEditModalStates.name.error}
            />
            <InputBox
              label='Clinic Email'
              placeholder='eg, johnclinic@example.com'
              value={props.addEditModalStates.email.value}
              onChange={event => {
                props.setAddEditModalStates(prevVal => ({ ...prevVal, email: { value: event.target.value, error: '' } }));
              }}
              errorMessage={props.addEditModalStates.email.error}
            />
          </InputsSection>

          <InputsSection>
            <InputBox
              label='Clinic Phone'
              placeholder='eg, 123-456-789'
              value={props.addEditModalStates.phone.value}
              onChange={event => {
                props.setAddEditModalStates(prevVal => ({ ...prevVal, phone: { value: inputPhoneMasking(event.target.value), error: '' } }));
              }}
              errorMessage={props.addEditModalStates.phone.error}
            />
            {!(props.addEditModal.data && props.addEditModal.data._id) && (
              <InputBox
                type='password'
                label='Password'
                placeholder='Set Password'
                value={props.addEditModalStates.password.value}
                onChange={event => {
                  props.setAddEditModalStates(prevVal => ({ ...prevVal, password: { value: event.target.value, error: '' } }));
                }}
                errorMessage={props.addEditModalStates.password.error}
              />
            )}
          </InputsSection>

          <InputsSection>
            <TextArea
              label='Clinic Address'
              placeholder='692 SW. 53rd St. Irwin, PA 15642'
              value={props.addEditModalStates.address.value}
              onChange={event => {
                props.setAddEditModalStates(prevVal => ({ ...prevVal, address: { value: event.target.value, error: '' } }));
              }}
              errorMessage={props.addEditModalStates.address.error}
            />
          </InputsSection>

          <InputsSection>
            <div style={{ display: 'flex', gap: '1rem', flexDirection: 'column' }}>
              <p className={TextBox.form_input__label}>Allowed Modules</p>
              <div className='flex' style={{ gap: '2rem' }}>
                <ToggleSwitchWithLabel
                  label='Check-in module'
                  id='clinic-check-in'
                  checked={props.addEditModalStates.modules.value.checkIn}
                  onChange={() =>
                    props.setAddEditModalStates(prevVal => ({
                      ...prevVal,
                      modules: { value: { ...prevVal.modules.value, checkIn: !prevVal.modules.value.checkIn }, error: '' },
                    }))
                  }
                />
                <ToggleSwitchWithLabel
                  label='File Exchange'
                  id='clinic-file-sharing'
                  checked={props.addEditModalStates.modules.value.fileSharing}
                  onChange={() =>
                    props.setAddEditModalStates(prevVal => ({
                      ...prevVal,
                      modules: { value: { ...prevVal.modules.value, fileSharing: !prevVal.modules.value.fileSharing }, error: '' },
                    }))
                  }
                />
                <ToggleSwitchWithLabel
                  label='Questionnaire module'
                  id='questionnaire-module'
                  checked={props.addEditModalStates.modules.value.questionnaire}
                  onChange={() =>
                    props.setAddEditModalStates(prevVal => ({
                      ...prevVal,
                      modules: { value: { ...prevVal.modules.value, questionnaire: !prevVal.modules.value.questionnaire }, error: '' },
                    }))
                  }
                />
                
              </div>
            </div>
          </InputsSection>

          <ModalButtons
            submitButtonLabel={props.addEditModal.data && props.addEditModal.data._id ? 'Update Clinic' : 'Add Clinic'}
            cancelButtonLabel='Cancel'
            onCancel={props.onCloseModal}
          />
        </ModalForm>
      )}
    </Modal>
  );
};

export default AddEditModal;
